const routes = [
  { route: "/home", name: "HOME" },
  { route: "/experience", name: "EXPERIENCE" },
  { route: "/projects", name: "PROJECTS" },
  { route: "/contacts", name: "CONTACT" },
];

export default routes;
